import { render, staticRenderFns } from "./ChildSupportComponent.vue?vue&type=template&id=53d22b57"
import script from "./ChildSupportComponent.vue?vue&type=script&lang=js"
export * from "./ChildSupportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports